(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/use-statistics-data.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/use-statistics-data.js');
"use strict";


const {
  useEffect,
  useState
} = React;
const useStatisticsData = (participantId, fetchFn) => {
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (participantId && fetchFn) {
      setData(undefined);
      setIsLoading(true);
      fetchFn(participantId, (err, response) => {
        if (err) {
          setError(err);
        } else {
          setData(response);
        }
        setIsLoading(false);
      });
    }
  }, [participantId, fetchFn]);
  return [data, error, isLoading];
};
svs.racing_game.components.statistics.useStatisticsData = useStatisticsData;

 })(window);